/**
 * Profils officiels Conakry en Poche.
 * Un réseau sans href reste visible mais désactivé (gris).
 */
export const SOCIAL_LINKS = [
  {
    id: 'facebook',
    label: 'Facebook',
    href: 'https://www.facebook.com/Conakryenpoche/'
  },
  {
    id: 'instagram',
    label: 'Instagram',
    href: null
  },
  {
    id: 'twitter',
    label: 'X',
    href: null
  }
];
